import { Component, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { SortDescriptor } from '@progress/kendo-data-query';
import { Observable } from 'rxjs';
import { letterViewModel } from '../../../../shared/common/viewmodels/letter-viewmodel';
import { LetterService } from '../../services/letter.service';
import { WindowService } from '@progress/kendo-angular-dialog';
import { Global } from '../../../../app.global';
import { SettingsService } from '../../../../authentication/services/settings.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'letter-management',
  templateUrl: './letter-management.component.html',
  styleUrls: ['./letter-management.component.scss'],
  providers: [LetterService],
})
export class LetterManagementComponent {
  public gridItems: Observable<GridDataResult>;
  public pageSize = 10;
  public skip = 0;
  public sortDescriptor: SortDescriptor[] = [];
  public filterTerm: number = null;
  public letters: Array<letterViewModel> = [];
  public columns: any[] = [];
  public letter = {
    content: '',
    documents: [],
    reasons: [],
  };
  public letterContent: string;
  public gridData: any = this.letters;
  public gridDataResult: GridDataResult = {
    data: this.letters,
    total: this.letters.length,
  };
  public operatingMode: string = '';

  constructor(
    public global: Global,
    private service: LetterService,
    private modalService: NgbModal,
    private windowService: WindowService,
    private settingsService: SettingsService
  ) {
    this.loadGridItems();
    this.global.isPcnPanelLocked = false;
    this.loadOperatingMode();
  }

  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.loadGridItems();
  }

  public showLetter(template: TemplateRef<string>, dataItem: any) {
    console.log(dataItem.letterId);
    this.service.getLetter(dataItem.letterId).subscribe((result) => {
      if (result) {
        this.letterContent = result.letterHtml;
        this.windowService.open({
          title: 'Letter sent from Response Master',
          content: template,
          width: 1000,
          height: 700,
        });
      }
    });
  }
  public handleSortChange(descriptor: SortDescriptor[]): void {
    this.sortDescriptor = descriptor;
  }

  private loadOperatingMode(): void {
    this.settingsService.getApplicationSetting('OperatingMode').subscribe(
      (result) => {
        this.operatingMode = result || '';
      },
      (error) => {
        console.error('Failed to load OperatingMode setting', error);
        this.operatingMode = '';
      }
    );
  }

  public RetryAllTodaysLettersForUser() {
    this.service.RetryAllTodaysLettersForUser().subscribe((result) => {
      this.loadGridItems();
      location.reload();
    });
  }

  public RetryLetter(letterId) {
    this.service.RetryLetter(letterId).subscribe((result) => {
      this.loadGridItems();
      location.reload();
    });
  }

  private loadGridItems(): void {
    this.service.getTodaysLettersForUser().subscribe((result) => {
      if (result) {
        // console.log(result);
        this.letters = result;

        this.gridDataResult.data = this.letters;
        this.gridDataResult.total = this.letters.length;

        this.gridData = this.gridDataResult;
      }
    });
  }
}
